import LoginComponent from '../components/login/login.jsx'

const Login = () => <LoginComponent />

export default Login;